(function() {
'use strict';

angular
    .module('searchUnit')
    .directive('transferSearchUnit', transferSearchUnit);

function transferSearchUnit(
    $location,
    searchUnitService,
    sharedSearchUnitService,
    occupancyService,
    autocompleter,
    $rootScope,
    transferSearch
) {
    // Configuration part, mandatory in every searchunit directive with delayed linker
    sharedSearchUnitService.addDelayedLinker(_delayedLinker, 'transferSearchUnit');

    return {
        restrict: 'E',
        replace: true,
        scope: {
            areaOverride: '@'
        },
        templateUrl: 'partials/searchunit/transfer',
        controller: 'SharedSearchUnit',
        link(scope, el, attr, controller) {
            return sharedSearchUnitService.initializeArea(scope, el, attr, controller, 'transferSearchUnit');
        }
    };

    function _delayedLinker(scope, el, attr, ssu) {
        const mode = sharedSearchUnitService.getAreaInfo(scope.areaOverride).mode;
        scope.model = {};
        scope.$watch(() => transferSearch.getTransfersTimeApprovalRequired(TRPCONFIG.Domain.EnableTransfersTimeApproval), value => {
            scope.requiresTimeApproval = value;
        });

        // ab-test code:
        // var $root = angular.element(document.body).scope().$root;
        // $root.transferDirectionStyle = 'radio';
        // $root.$evalAsync();
        scope.transferDirectionStyle = () => $rootScope.transferDirectionStyle || TRPCONFIG.Domain.TransferDirectionStyle;

        // Props on scope
        scope.directionOps = _.mapValues(
                // Numbers are required by `searchUnitService` but numeric keys are always strings
                // Swap key/value and coerce to number
                _.invert(searchUnitService.getDirectionStrings()), v => v * 1
            );
        scope.transferTypes = _.mapValues(
            _.invert(searchUnitService.getTransferTypeStrings()), v => v * 1
            );
        const destinationTypePointTypeMap = {
            0: searchUnitService.pointType.Unknown,
            1: searchUnitService.pointType.Estab,
            2: searchUnitService.pointType.Location,
            3: searchUnitService.pointType.Unknown,
            4: searchUnitService.pointType.Unknown,
            5: searchUnitService.pointType.Unknown,
            10: searchUnitService.pointType.Unknown
        };
        const pointTypeDestinationTypeMap = {
            [searchUnitService.pointType.Unknown]: 0,
            [searchUnitService.pointType.Estab]: 1,
            [searchUnitService.pointType.Location]: 2
        };

        // Methods on scope
        scope.destinationAirportSelect = destinationAirportSelect;
        scope.destinationAirportDeselect = destinationAirportDeselect;
        scope.resortSelect = searchUnitService.setResort;
        scope.resortDeselect = resortDeselect;
        scope.directionSelect = directionSelect;
        scope.search = search;
        scope.transferTypeSelect = transferTypeSelect;
        scope.dropOffPointDeselect = dropOffPointDeselect;
        scope.pickUpPointDeselect = pickUpPointDeselect;
        scope.pickUpPointSelect = pickUpPointSelect;
        scope.dropOffPointSelect = dropOffPointSelect;
        scope.pointToPointOneWay = pointToPointOneWay;

        // Initialise form
        _restoreSearchCriteria();

        function _restoreSearchCriteria() {
            const destination = searchUnitService.getDestinationAirport() || {};
            const airportCode = destination.Code || destination.DestinationAirports || $location.search().air || '';
            if (airportCode && airportCode.indexOf(',') === -1) {
                autocompleter.lookup('transfers', airportCode).then(response => {
                    destinationAirportSelect(_.filter(response.data, { Code: airportCode })[0]);
                });
            }
            scope.resort = searchUnitService.getResort();
            scope.model.direction = searchUnitService.getDirection();
            scope.startDate = searchUnitService.startDate(mode);
            scope.endDate = searchUnitService.endDate(mode);
            scope.isStartTimeApprovedByCustomer = searchUnitService.isStartTimeApprovedByCustomer(mode);
            scope.isEndTimeApprovedByCustomer = searchUnitService.isEndTimeApprovedByCustomer(mode);
            scope.occupancy = [occupancyService.reduceOccupancy()];
            directionSelect();
            scope.transferType = searchUnitService.getTransferType();
            transferTypeSelect();
            if (TRPCONFIG.Domain.PointToPointTransferSearchEnabled) {
                const pickUpPoint = searchUnitService.getTransferPickUpPoint();
                const dropOffPoint = searchUnitService.getTransferDropOffPoint();
                if (pickUpPoint) {
                    pickUpPoint.Type = pointTypeDestinationTypeMap[pickUpPoint.Type];
                }
                if (dropOffPoint) {
                    dropOffPoint.Type = pointTypeDestinationTypeMap[dropOffPoint.Type];
                }
                pickUpPointSelect(pickUpPoint);
                dropOffPointSelect(dropOffPoint);
            }
        }

        function destinationAirportSelect(a) {
            scope.destinationAirport = a;
            searchUnitService.setDestinationAirport(a, true);
        }

        function destinationAirportDeselect() {
            scope.destinationAirport = null;
            return searchUnitService.setDestinationAirport(null);
        }

        function resortDeselect() {
            searchUnitService.setResort(null);
        }

        function directionSelect() {
            const dir = scope.model.direction;

            if (dir != null) {
                scope.isOneWay = (dir === 2); // Airport to resort only
                scope.isReturnOnly = (dir === 3); // Resort to airport only

                // Restore any existing search dates
                // `setDirection()` below may have set them to `null`
                restoreDates();

                // Update search
                searchUnitService.setDirection(dir);
            }
        }

        function restoreDates() {
            if (!scope.isReturnOnly && scope.startDate) {
                searchUnitService.startDate(mode, scope.startDate);
            }
            if (!scope.isOneWay && scope.endDate) {
                searchUnitService.endDate(mode, scope.endDate);
            }
        }

        function search() {
            occupancyService.setOccupancy(scope.occupancy);
            ssu.lockScreen('SEARCHINGTRANSFERS');
            sharedSearchUnitService.search(undefined, ssu.showErrors, {
                areaOverride: scope.areaOverride,
                enableTransfersTimeApproval: TRPCONFIG.Domain.EnableTransfersTimeApproval
            });
        }

        function transferTypeSelect() {
            scope.isAirportTransfer = (scope.transferType === searchUnitService.transferTypes.AirportTransfer);
            searchUnitService.setTransferType(scope.transferType);
        }

        function pickUpPointDeselect() {
            scope.pickUpPoint = null;
            searchUnitService.setTransferPickUpPoint(null);
        }

        function dropOffPointDeselect() {
            scope.dropOffPoint = null;
            searchUnitService.setTransferDropOffPoint(null);
        }

        function pickUpPointSelect(p) {
            scope.pickUpPoint = p;
            if (p) {
                searchUnitService.setTransferPickUpPoint({
                    Type: destinationTypePointTypeMap[p.Type],
                    Code: p.Code,
                    Description: p.Description || p.Title
                });
            }
        }

        function dropOffPointSelect(d) {
            scope.dropOffPoint = d;
            if (d) {
                searchUnitService.setTransferDropOffPoint({
                    Type: destinationTypePointTypeMap[d.Type],
                    Code: d.Code,
                    Description: d.Description || d.Title
                });
            }
        }

        function pointToPointOneWay() {
            if (scope.isPointToPointOneWay) {
                scope.model.direction = 2;
                scope.isOneWay = true;
            } else {
                scope.model.direction = 1;
                scope.isOneWay = false;
            }
            searchUnitService.setDirection(scope.model.direction);
        }
    }
}
})();
